import React from 'react'
import Style from './index.module.less'
import { getMoney } from '@hlj/hlj-utils'
import { isImageMogr2 } from '@util'

export default ({ item, onChange, checked }) => (
  <div className={Style.area}>
    {/* {JSON.stringify(item)} */}
    {/* <Checkbox
      className={Style.checkbox}
      checked={checked}
      onChange={e => onChange(item)}
    /> */}
    <img
      className={Style.img}
      src={isImageMogr2(item.cover_path || item.coverUrl, 160, 100)}
    />
    <div className={Style.title}>{item.title || item.name}</div>
    {item.commodity_type == 0 && (
      <div className={Style.price}>
        <span>{getMoney(item.actual_price)}</span>
        <span>{getMoney(item.market_price)}</span>
      </div>
    )}
  </div>
)
